module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3_3072.e56623e8.jpg";